// Views whose data does not exist in the shared Core yet (see docs/integration/member-core-contract.md).
// Without data there is nothing real to show, so they render an honest "not available" state.
// Since B9 every former placeholder (M98, M99) has its own V3 view; the list stays for future gaps.
export const MEMBER_VIEWS = [];
